import { SharedModule } from './../shared/shared.module';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TravelersRoutingModule } from './travelers-routing.module';
import { ListComponent } from './components/list/list.component';
import { ViewTravelerComponent } from './modals/view-traveler/view-traveler.component';


@NgModule({
  declarations: [ListComponent, ViewTravelerComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    SharedModule,
    TravelersRoutingModule
  ]
})
export class TravelersModule { }
